module.exports = __webpack_public_path__ + "img/banner_bg@3x_EN.d2adbaad.png";